import React from 'react';
import { PaperStyledStyled } from './j-paper.styled';
import { StackProps } from '@mui/material';

interface IJpaper extends StackProps {
  children: React.ReactNode;
  attr?: { noPadding?: boolean; fullHeight?: boolean };
}
const Jpaper = ({
  children,
  attr: { noPadding = false, fullHeight = false } = {},
  ...props
}: IJpaper) => {
  if (!children) {
    return null; // Don't render anything if there are no children
  }
  return (
    <PaperStyledStyled attr={{ noPadding, fullHeight }} {...props}>
      {children}
    </PaperStyledStyled>
  );
};

export default Jpaper;
